import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "netdata-press",
  "use": "netdata-press-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"netdata-press\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.535 2H.158l7.311 14h3.567c3.756 0 6.8-3.017 6.806-6.746C17.84 5.251 14.571 2.007 10.535 2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol